import { render } from "./AddEndpointDialog.vue?vue&type=template&id=161616b3&scoped=true&ts=true"
import script from "./AddEndpointDialog.ts?vue&type=script&lang=ts"
export * from "./AddEndpointDialog.ts?vue&type=script&lang=ts"

import "./AddEndpointDialog.vue?vue&type=style&index=0&id=161616b3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161616b3"]])

export default __exports__